import { getResultsBySectionUrl, getResultsUrl } from "../config/Config";
import { getRequest } from "./ServiceHelper";

export class ResultService {
  static getResultsByLoAndTerms = (loId, termIds) => {
    const param = {};
    if (loId && termIds) {
      param.loId = loId;
      param.termIds = termIds;
    }
    return getRequest(getResultsUrl(), param);
  };

  static getResultsBySectionCanvasIds = (courseCanvasIds) => {
    const param = {};
    if (courseCanvasIds) {
      param.courseCanvasIds = courseCanvasIds;
    }
    return getRequest(getResultsBySectionUrl(), param);
  };
}
